import {TAB_ENUM} from 'app/Components/Page/SelfCarePage/Constant';

export function getCellularReportIdentifiers(selectedSubscriber, selfcarePage, loginData) {
  const phone = selectedSubscriber?.replace(/\D/g, '') || '';
  const product = selfcarePage?.subscribersByProduct?.[TAB_ENUM.Cellular]?.find(
    (item) => (item.productSubscriberNo || '').replace(/\D/g, '') === phone,
  );

  return {
    banId: product?.ban || loginData?.userDetails?.Ban || '',
    psId: product?.productId || product?.psId || product?.psid || '',
    cmrId: product?.consumerId || '',
  };
}
